import XLSFileUpload from "../../FileUpload";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../styles/vendors/style";
import React, { useEffect, useRef, useState } from "react";
import Stepper1 from "../../components/Stepper";
import Header from "../../components/Header";
import PageLoading from "../../components/PageLoading";
import DupontButton from "../../components/DupontButton";
import { getLastFileDetails } from "../../network/cipAPI";
import {
  storeCostInformation,
  storeDefaultInformation,
  storeFileId,
  storePlantDetails,
  storeUnits,
  storeApp,
} from "../../Store/TemplateStore/template.action";
import { useTranslation } from "react-i18next";
import { Language_Currency_Mapping } from "./Settings/settingsOptions.config";
import LifetimeAdvisorHome from "../lifetimeAdvisorHome";
import { getFormattedDate, extractPlantId } from "../../utils/Utils";
import { API_URLS } from "../../network/appUrls";
import Footer from "../../common/footer";

const steps = (t) => [
  t("stepper.performanceData"),
  t("stepper.identifyCIP"),
  t("stepper.cleaningEffectiveness"),
  // t("stepper.fouling"),
  t("stepper.predict"),
];
const RoAdvisorHome = (props) => {
  const { t, i18n } = useTranslation();

  const [activeStep, setActiveStep] = useState(0);
  const userName = useSelector((state) => state.userName);
  const token = useSelector((state) => state.token);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const xlmRef = useRef(null);
  const renamingText =
    activeStep === 3
      ? t("appHome.roReplacementAdvisor")
      : t("ValueStrings.next");
  const handleNext = () => {
    setIsBackClicked(false);
    if (xlmRef && xlmRef.current && (activeStep === 0 || activeStep === 1)) {
      xlmRef.current.onNextClicked();
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(false);
  const [fileDetailsLoaded, setFileDetailsLoaded] = useState(false);
  const [disableNextButton, setDisableNextButton] = useState(false);

  const handleBack = () => {
    setIsBackClicked(true);
    if (activeStep - 1 >= 0) setActiveStep(activeStep - 1);
  };
  //const isLocalhost = window.location.hostname === "localhost";
  //const basePath = isLocalhost ? "/" : "/roadvisor/";
  //const basePath = isLocalhost ? "/" : window.location.origin;
  const basePath = API_URLS.basePath;

  const plantId = extractPlantId();

  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      dispatch(storeApp("ca"));
      getLastFileDetail();
    }
  }, [token]);

  const getLastFileDetail = async () => {
    try {
      const fileDetails = await getLastFileDetails();
      //i18n.changeLanguage(fileDetails.data?.lang);
      if (fileDetails && fileDetails?.data) {
        setIsFirstTimeLoad(true);
        const data = fileDetails.data;
        const plantInformation = {
          plantLocation: `${
            data?.city ? ` ${data?.city}, ${data?.country}` : `${data?.country}`
          }`,
          plantName: data?.name,
          water_type: data?.water_type,
          num_trains: fileDetails.data?.num_trains,
          tol_num_modules: data?.tol_num_modules,
          tol_active_area: data?.tol_active_area,
          sel_train: data?.sel_train,
          sel_rack: data?.sel_rack,
          sel_modules_per_rack: data?.sel_modules_per_rack,
          sel_active_area: data?.sel_active_area,
          dataset_name: `${userName}_${data.name}_${
            data?.water_type
          }_${getFormattedDate(data?.file?.min_date)} to ${getFormattedDate(
            data?.file?.max_date
          )}`,
          sel_module_used: data?.sel_module_used,
          is_dupont_element: data?.is_dupont_element ? "Yes" : "No",
          sel_segment: data?.sel_segment,
        };
        dispatch(storePlantDetails(plantInformation));

        const costInfo = data?.cost;
        const constInformation = {
          energyPrice: costInfo?.energy_price,
          acidPrice: costInfo?.cip_acid_price,
          alkaliPrice: costInfo?.cip_alkali_price,
          waterPrice: costInfo?.water_price,
          costofDownTime: costInfo?.downtime_cost,
          additional_chemical_price: costInfo?.cip_solution,
          cebAcidPrice: costInfo?.ceb_acid_price,
          cebAlkaliPrice: costInfo?.ceb_alkali_price,
          ceb_additional_chemical_price: costInfo?.ceb_solution,
        };
        dispatch(storeCostInformation(constInformation));
        const defaultInfo = data?.default_cip;
        const defaultInformation = {
          design_bw_duration: defaultInfo?.design_bw_duration,
          design_duration_btw_bw: defaultInfo?.design_duration_btw_bw,

          acid_ceb_duration: defaultInfo?.acid_ceb_duration,
          acid_ceb_soak_duration: defaultInfo?.acid_ceb_soak_duration,
          acid_used_per_ceb: defaultInfo?.acid_used_per_ceb,
          acid_ceb_ph: defaultInfo?.acid_ceb_ph,
          acid_ceb_temp: defaultInfo?.acid_ceb_temp,
          alkali_ceb_duration: defaultInfo?.alkali_ceb_duration,
          alkali_ceb_soak_duration: defaultInfo?.alkali_ceb_soak_duration,
          alkali_used_per_ceb: defaultInfo?.alkali_used_per_ceb,
          alkali_ceb_ph: defaultInfo?.alkali_ceb_ph,
          alkali_ceb_temp: defaultInfo?.alkali_ceb_temp,

          acid_cip_duration: defaultInfo?.acid_cip_duration,
          acid_cip_soak_duration: defaultInfo?.acid_cip_soak_duration,
          acid_used_per_cip: defaultInfo?.acid_used_per_cip,
          acid_cip_ph: defaultInfo?.acid_cip_ph,
          acid_cip_temp: defaultInfo?.acid_cip_temp,
          alkali_cip_duration: defaultInfo?.alkali_cip_duration,
          alkali_cip_soak_duration: defaultInfo?.alkali_cip_soak_duration,
          alkali_used_per_cip: defaultInfo?.alkali_used_per_cip,
          alkali_cip_ph: defaultInfo?.alkali_cip_ph,
          alkali_cip_temp: defaultInfo?.alkali_cip_temp,
        };
        dispatch(storeDefaultInformation(defaultInformation));

        const settings = data?.setting;
        const unitInformation = {
          flux: settings?.plant_name,
          temperature: settings?.temperature,
          filtrate_suspended: settings?.filtrate_suspended,
          feed_suspended: settings?.feed_suspended,
          pressure: settings?.pressure,
          flow: settings?.flow,
          flux: settings?.flux,
          volume: settings?.volume,
          mass: settings?.mass,
          currency:
            settings?.currency ||
            parseFloat(Language_Currency_Mapping(i18n.language).currency),
          conversion_rate:
            settings?.conversion_rate ||
            parseFloat(
              Language_Currency_Mapping(i18n.language).conversion_rate
            ),
          feed_water_permeate_factor: settings?.feed_water_permeate_factor,
          feed_water_factor: settings?.feed_water_factor,
        };
        dispatch(storeUnits(unitInformation));
        setTimeout(() => {
          setIsFirstTimeLoad(false);
        }, 1000);
      }
    } catch (err) {
      console.log("Error " + err);
    } finally {
      setFileDetailsLoaded(true);
    }
  };

  return (
    <>
      {activeStep !== 5 && (
        <div className="container-main">
          <Header activeStep={activeStep} />
          {/* {activeStep === 0 && (
          <div>
            {" "}
            <Welcome
              message={t("welcomeString.cleaningAdvisorIntroduction")}
            ></Welcome>
          </div>
        )} */}
          <div className="main-container">
            <div className="content-container">
              <Stepper1
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleBack={handleBack}
                handleNext={handleNext}
                steps={steps}
                renamingText={renamingText}
                disableNextButton={disableNextButton}
              />
              {fileDetailsLoaded ? (
                <div>
                  <XLSFileUpload
                    ref={xlmRef}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    isFirstTimeLoad={isFirstTimeLoad}
                    isBackClicked={isBackClicked}
                    setIsBackClicked={setIsBackClicked}
                    setDisableNextButton={setDisableNextButton}
                  />
                </div>
              ) : (
                <PageLoading customHeight={"350px"} />
              )}
            </div>
            <div className="footer-container">
              <div className="button">
                <DupontButton
                  type="tertiary"
                  onClick={handleBack}
                  // disabled={activeStep === 0}
                >
                  {activeStep === 0 ? (
                    <Link
                      to={`${basePath}Home?plantId=${plantId}`}
                      className="dupont-btn__tertiary--primary "
                    >
                      &lt; {t("ValueStrings.back")}
                    </Link>
                  ) : (
                    ` < ${t("ValueStrings.back")}`
                  )}
                </DupontButton>
                <DupontButton
                  type="tertiary"
                  onClick={handleNext}
                  // disabled={activeStep === 4 && disableNextButton}
                  // temporarily disable next of predict screen
                  disabled={activeStep === 3}
                >
                  {renamingText} &gt;
                </DupontButton>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      )}

      {activeStep === 5 && <LifetimeAdvisorHome />}
    </>
  );
};

export default RoAdvisorHome;
